import React, {useState} from "react";
import {Eye, EyeOff} from "react-feather";

const PasswordField2 = ({labelName = "Password", error, className, ...props}) => {
  const [fieldType, setFieldType] = useState("password");

  const changeFieldType = () => {
    setFieldType(fieldType === "password" ? "text" : "password");
  };

  return (
    <div className="flex w-full items-start flex-col gap-2">
      <label className="text-sm font-medium text-gray-700" htmlFor="password">
        {labelName}
      </label>

      <div className={`
        relative w-full flex items-center h-12
        border border-gray-300 rounded-lg
        bg-white
        transition-all duration-200 ease-in-out
        focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent
        hover:border-gray-400
        ${error ? 'border-red-500 focus-within:ring-red-500' : ''}
      `}>
        <div className="flex items-center gap-3 px-4 flex-1 h-full">
          <svg
            className="w-5 h-5 text-gray-400"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
          </svg>
          <input 
            type={fieldType} 
            className={`
              flex-1 text-sm text-gray-900 placeholder-gray-500
              bg-transparent border-none outline-none h-full
              ${className}
            `}
            {...props} 
          />
        </div>

        <button
          type="button"
          className="px-4 h-full text-gray-400 hover:text-gray-600 transition-colors duration-200"
          onClick={changeFieldType}
        >
          {fieldType === "text" ? (
            <Eye className="w-5 h-5" />
          ) : (
            <EyeOff className="w-5 h-5" />
          )}
        </button>
      </div>

      {error && (
        <div className="flex items-center gap-2 text-red-600 text-sm">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          <span>{error}</span>
        </div>
      )}
    </div>
  );
};

export default PasswordField2;
